package com.neurobs.ccab

class DatabaseCache[T] {
  var cache: Map[Long, Either[String, T]] = Map()
  def searchCache(dbId: Long): Option[Either[String, T]] = cache.get(dbId)

  def updateCache(dbId: Long, data: T) = {
    cache = cache.updated(dbId, Right(data))
  }
  def updateCache(dbId: Long, error: String) = {
    cache = cache.updated(dbId, Left(error))
  }
}
